<template>
    <rkm-area
        no-margin-top
        title="Status para encaminhamento"
        type="fieldset"
    >
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="filteredStatusPara"
                        :validations="validations.status"
                        label="Status"
                        show-default-option
                        text-field="nome"
                        v-model="model.statusId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="data.model.statusPara"
            hide-filters
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-area>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        filteredStatusPara() {

            return this.data.form.status.filter(s => !this.data.model.statusPara.find(s2 => s2.id === s.id))
        },
        validations() {

            return {
                status: { required: true },
            }
        }
    },
    data: () => ({
        model: {
            statusId: null,
        },
        fields: [
            {
                key: 'nome',
                label: 'Nome',
                sortable: true,
            },
            {
                class: 'col-min',
                key: 'actions',
                label: 'Ações',
            },
        ],
    }),
    methods: {
        add() {

            const status = this.clone(this.data.form.status.find(s => s.id === this.model.statusId))

            this.data.model.statusPara.push(status)

            this.resetForm()
        },
        resetForm() {

            this.model.statusId = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        handleDestroy({ id }) {

            const destroy = async () => this.data.model.statusPara
                .splice(this.data.model.statusPara.findIndex(s => s.id === id), 1)

            this.showDeleteConfirmation('Deseja realmente excluir o status?', destroy)
        },
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>